// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xLoadingOverlay } from "@ces/App/Handlers/XNG/Common";
import { addToEndOfChain, addToStartOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";

type HandlerType = typeof PopulateApiParameter;

export const setIsLoading: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "add", value: "create_request_quote" }));
};

export const setLoadingCompleted: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "remove", value: "create_request_quote" }));
};

addToStartOfChain(chain, setIsLoading);
addToEndOfChain(chain, setLoadingCompleted);
